module.exports = __webpack_public_path__ + "media/images/emblems/Vich-coat_of_arms-28dd3cebc57c0831aad2f375cdc9b52a.svg";